export default __webpack_public_path__ + "static/community_4-9cae57015c161aa765f1de625d64caa4.jpg";